import React from "react";
import { IKImage } from "imagekitio-react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserCircle } from "@fortawesome/free-solid-svg-icons";
import Rate from "../../../components/Rating";
const Review = ({ reviewData, userToggle }) => {
  const months = [
    "Jan",
    "Feb",
    "March",
    "April",
    "May",
    "June",
    "July",
    "Aug",
    "Sept",
    "Oct",
    "Nov",
    "Dec",
  ];
  //style={{background :'linear-gradient(180deg, #086788 0%, rgba(45, 161, 201, 0.99) 100%)'}}
  return !userToggle ? (
    <div className="flex flex-col rounded-2xl p-2.5">
      <div className="h-[450px] rounded-2xl  bg-[#E2F8FF] p-4 md:p-6">
        <div className="mb-5 flex w-full flex-row items-center justify-start">
          {reviewData?.user_image_url ? (
            <div
              className="relative cursor-pointer"
              onClick={(e) => {
                if (reviewData?.linkedin_url?.length > 0) {
                  window.open(reviewData?.linkedin_url, "_blank");
                }
              }}
            >
              <div className="w-full">
                <img
                  src={reviewData?.user_image_url}
                  className=" h-14 w-14 rounded-full ring ring-[#0654A2] md:h-[80px] md:w-[80px] "
                  width={window.innerWidth > 758 ? "80px" : "56px"}
                  height={window.innerWidth > 758 ? "80px" : "56px"}
                  alt="profile image"
                />
              </div>
              {reviewData?.linkedin_url?.length > 0 && (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                  }
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                  className=" absolute left-9 top-9 h-5 md:left-14 md:top-14 md:h-6"
                />
              )}
            </div>
          ) : (
            <FontAwesomeIcon
              icon={faUserCircle}
              className={"mt-2 h-12 w-14 rounded-full"}
            />
          )}
          <div className=" ml-3 flex flex-1 flex-col md:ml-4">
            <h1
              className="text-sm font-semibold text-black  md:text-lg"
              style={{
                lineHeight: "20px",
              }}
            >
              {reviewData?.testimonial_title}
            </h1>
            <h4 className="mt-1 text-xs text-stone-500 md:text-sm">
              - {reviewData?.name}
            </h4>
          </div>
        </div>
        {/* <div className=" -mt-2 md:-mt-2">
            <Rate
                rating={5}
                color={{
                  filled: "#FFD700",
                  unfilled: "#808080",
                }}
                count={5}
                size={"lg"}
                isReadOnly={true}
              />
          </div> */}
        <div className=" mt-2 self-center text-sm text-pricing_blue md:mt-4 md:text-base md:leading-5">
          {reviewData?.testimonial}
        </div>
      </div>
    </div>
  ) : (
    <div
      className="flex  w-full  flex-col  rounded-2xl"
      style={{
        background:
          "linear-gradient(180deg, #086788 0%, rgba(45, 161, 201, 0.99) 100%)",
      }}
    >
      <div className="h-[450px] rounded-2xl bg-[#E2F8FF] p-4 md:p-6">
        <div className="mb-5 flex w-full flex-row items-center justify-start">
          {reviewData?.user_image_url ? (
            <div
              className="relative cursor-pointer"
              onClick={(e) => {
                if (reviewData?.linkedin_url?.length > 0) {
                  window.open(reviewData?.linkedin_url, "_blank");
                }
              }}
            >
              <div className="w-full">
                <img
                  src={reviewData?.user_image_url}
                  className=" h-14 w-14 rounded-full ring ring-[#0654A2] md:h-[80px] md:w-[80px] "
                  width={window.innerWidth > 758 ? "80px" : "56px"}
                  height={window.innerWidth > 758 ? "80px" : "56px"}
                  alt="profile image"
                />
              </div>
              {reviewData?.linkedin_url?.length > 0 && (
                <img
                  urlEndpoint="https://img.learntube.ai/public-assets/"
                  src={
                    "https://img.learntube.ai/public-assets/Content_player/LinkdIn.png?updatedAt=1681563676400"
                  }
                  transformation={[
                    {
                      height: "160",
                      width: "160",
                    },
                  ]}
                  className=" absolute left-9 top-9 h-5 md:left-14 md:top-14 md:h-6"
                />
              )}
            </div>
          ) : (
            <FontAwesomeIcon
              icon={faUserCircle}
              className={"mt-2 h-12 w-14 rounded-full"}
            />
          )}
          <div className=" ml-3 flex flex-1 flex-col md:ml-4">
            <h1
              className="text-sm font-semibold text-black  md:text-lg"
              style={{
                lineHeight: "20px",
              }}
            >
              {reviewData?.testimonial_title}
            </h1>
            <h4 className="mt-1 text-xs text-stone-500 md:text-sm">
              - {reviewData?.name}
            </h4>
          </div>
        </div>
        {/* <div className=" -mt-2 md:-mt-2">
            <Rate
                rating={5}
                color={{
                  filled: "#FFD700",
                  unfilled: "#808080",
                }}
                count={5}
                size={"lg"}
                isReadOnly={true}
              />
          </div> */}
        <div className=" mt-2 self-center text-sm text-pricing_blue md:mt-4 md:text-base md:leading-5">
          {reviewData?.testimonial}
        </div>
      </div>
    </div>
  );
};

export default Review;
